import { render, staticRenderFns } from "./yunqiao.vue?vue&type=template&id=4051d144&"
import script from "./yunqiao.vue?vue&type=script&lang=js&"
export * from "./yunqiao.vue?vue&type=script&lang=js&"
import style0 from "./yunqiao.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports